import { dashboardConstants } from 'Constants/dashboard.constants';

const initialState = {
    dashboardId: '',
    dashboardList:[],
    loading: false,
    totalRecords: 0,
    error:false,
    currentPage:1,
  }
  
  export function dashboard(state = initialState, action={}) {
    const { id, dashboard } = action;
    switch (action.type) {
      case dashboardConstants.DASHBOARD_REQUEST:
        return { ...state, loading: true, error:null };
      case dashboardConstants.DASHBOARD_GET_SUCCESS:
        return {
          ...state,
          dashboardId: id,
          dashboardList: dashboard,
          loading: false,
          formLoading:false
        };
      case dashboardConstants.DASHBOARD_FAILURE:
        return {
            ...state,
            loading: false,   
            error:true
        } 
  
      default:
        return state;
    }
  }